module.exports = __webpack_public_path__ + "img/pointer-top.f259d44f.svg";